<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-subtitle-1">Reporte CEAA</span>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              class="text-capitalize mr-2"
              small
              tile
              :disabled="!seleccion.length || generando"
              :loading="generando"
              @click="generarRequisicion"
            >
              <v-icon left small>mdi-file-document-outline</v-icon>
              Generar requisición
            </v-btn>
            <v-btn color="primary" dark class="text-capitalize" small tile :loading="cargando" @click="initialize">
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>

          <v-card-text>
            <div class="text-caption grey--text text--darken-1 mb-3">
              CEAA acepta o rechaza la comisión. Aquí se genera la requisición.
              Queda pagada cuando esa requisición está Procesada y el egreso queda Autorizado.
            </div>

            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="filtros.contactoDesde" label="Contacto desde" type="date" filled dense hide-details clearable />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="filtros.contactoHasta" label="Contacto hasta" type="date" filled dense hide-details clearable />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="filtros.inscripcionDesde" label="Inscripción desde" type="date" filled dense hide-details clearable />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="filtros.inscripcionHasta" label="Inscripción hasta" type="date" filled dense hide-details clearable />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-select v-model="filtros.estatus" :items="opcionesEstatus" label="Estatus" filled dense hide-details clearable />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-select v-model="filtros.decision" :items="opcionesDecision" label="Decisión" filled dense hide-details clearable />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-select v-model="filtros.pago" :items="opcionesPago" label="Pagada" filled dense hide-details clearable />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="search" label="Buscar" filled dense hide-details append-icon="mdi-magnify" clearable />
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="filas"
              item-key="telefono"
              class="elevation-0 mt-4"
              :search="search"
              :loading="cargando"
              dense
              :footer-props="{ 'items-per-page-options': [10, 25, 50, 100, -1] }"
            >
              <template v-slot:item.seleccion="{ item }">
                <v-checkbox
                  v-if="puedeSeleccionar(item)"
                  v-model="seleccion"
                  :value="item.telefono"
                  class="mt-0"
                  hide-details
                  dense
                />
              </template>
              <template v-slot:item.fecha_contacto="{ item }">{{ formatoFecha(item.fecha_contacto) }}</template>
              <template v-slot:item.fecha_inscripcion="{ item }">{{ formatoFecha(item.fecha_inscripcion) }}</template>
              <template v-slot:item.fecha_pago="{ item }">
                <v-chip v-if="item.pago_alumno === 'por_validar'" small dark color="orange darken-1">
                  Falta de validación
                </v-chip>
                <span v-else>{{ formatoFecha(item.fecha_pago) }}</span>
              </template>
              <template v-slot:item.estatus="{ item }">
                <v-chip small dark :color="item.estatus === 'inscrito' ? 'green' : 'grey'">
                  {{ item.estatus === 'inscrito' ? 'Inscrito' : 'Solo contacto' }}
                </v-chip>
              </template>
              <template v-slot:item.comision="{ item }">{{ moneda(item.comision) }}</template>
              <template v-slot:item.decision="{ item }">
                <span v-if="item.estatus !== 'inscrito' || item.pago_alumno !== 'validado'" class="grey--text">—</span>
                <v-tooltip v-else-if="item.decision === 'rechazada' && item.notas" bottom max-width="320">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip small dark color="red" v-bind="attrs" v-on="on">
                      Rechazada
                      <v-icon right x-small>mdi-note-text-outline</v-icon>
                    </v-chip>
                  </template>
                  <span>{{ item.notas }}</span>
                </v-tooltip>
                <v-chip v-else small dark :color="colorDecision(item.decision)">
                  {{ textoDecision(item.decision) }}
                </v-chip>
              </template>
              <template v-slot:item.pago="{ item }">
                <v-chip small dark :color="item.pago === 'pagada' ? 'green' : 'orange'">
                  {{ item.pago === 'pagada' ? 'Pagada' : 'No pagada' }}
                </v-chip>
              </template>
              <template v-slot:item.requisicion_estatus="{ item }">
                <span v-if="item.id_requisicion">#{{ item.id_requisicion }} · {{ item.requisicion_estatus || 'Sin estatus' }}</span>
                <span v-else class="grey--text">Sin requisición</span>
              </template>
              <template v-slot:item.egreso_validado="{ item }">
                <v-chip v-if="item.id_requisicion" small dark :color="item.egreso_validado ? 'green' : 'grey'">
                  {{ item.egreso_validado ? 'Validado' : 'Sin validar' }}
                </v-chip>
                <span v-else class="grey--text">—</span>
              </template>
              <template v-slot:no-data>
                <span class="grey--text">Sin contactos con estos filtros</span>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargando || generando" />
  </v-container>
</template>

<script>
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
import validarErrores from '@/mixins/validarErrores'

function enRango(valor, desde, hasta) {
  if (!desde && !hasta) return true
  if (!valor) return false
  const dia = String(valor).slice(0, 10)
  if (desde && dia < desde) return false
  if (hasta && dia > hasta) return false
  return true
}

export default {
  name: 'ReporteCEAA',

  mixins: [validarErrores],

  components: { Alerta, carga },

  data: () => ({
    parametros: { dialogError: false, mensaje: '', color: '' },
    respuestaAlerta: false,
    cargando: false,
    generando: false,
    search: '',
    seleccion: [],
    contactos: [],
    filtros: {
      contactoDesde: null,
      contactoHasta: null,
      inscripcionDesde: null,
      inscripcionHasta: null,
      estatus: null,
      decision: null,
      pago: null,
    },
    opcionesEstatus: [
      { text: 'Inscrito', value: 'inscrito' },
      { text: 'Solo contacto', value: 'solo_contacto' },
    ],
    opcionesDecision: [
      { text: 'Pendiente', value: 'pendiente' },
      { text: 'Aceptada', value: 'aceptada' },
      { text: 'Rechazada', value: 'rechazada' },
    ],
    opcionesPago: [
      { text: 'Pagada', value: 'pagada' },
      { text: 'No pagada', value: 'no_pagada' },
    ],
    headers: [
      { text: '', value: 'seleccion', sortable: false, width: 48 },
      { text: 'Contacto', value: 'fecha_contacto' },
      { text: 'Nombre', value: 'nombre' },
      { text: 'Teléfono', value: 'telefono' },
      { text: 'Folio', value: 'folio' },
      { text: 'Estatus', value: 'estatus' },
      { text: 'ID alumno', value: 'id_alumno' },
      { text: 'Matrícula', value: 'matricula' },
      { text: 'Grupo', value: 'grupo' },
      { text: 'Inscripción', value: 'fecha_inscripcion' },
      { text: 'Pago del alumno', value: 'fecha_pago' },
      { text: 'Comisión', value: 'comision' },
      { text: 'Decisión', value: 'decision' },
      { text: 'Requisición', value: 'requisicion_estatus' },
      { text: 'Egreso', value: 'egreso_validado', sortable: false },
      { text: 'Pago', value: 'pago' },
    ],
  }),

  computed: {
    filas() {
      const f = this.filtros
      return this.contactos.filter(item =>
        enRango(item.fecha_contacto, f.contactoDesde, f.contactoHasta)
        && enRango(item.fecha_inscripcion, f.inscripcionDesde, f.inscripcionHasta)
        && (!f.estatus || item.estatus === f.estatus)
        && (!f.decision || item.decision === f.decision)
        && (!f.pago || item.pago === f.pago)
      )
    },
  },

  created() {
    this.initialize()
  },

  methods: {
    puedeSeleccionar(item) {
      return item.decision === 'aceptada' && item.estatus === 'inscrito' && !item.id_requisicion
    },

    async initialize() {
      this.cargando = true
      try {
        const { data } = await this.$http.post('ceaa.reporte.kpi')
        this.contactos = Array.isArray(data.contactos) ? data.contactos : []
        this.seleccion = this.seleccion.filter(tel => this.contactos.some(item => item.telefono === tel && this.puedeSeleccionar(item)))
      } catch (error) {
        this.contactos = []
        this.validarError(error.response && error.response.data ? error.response.data.message : 'No se pudo cargar el reporte')
      } finally {
        this.cargando = false
      }
    },

    async generarRequisicion() {
      this.generando = true
      try {
        const { data } = await this.$http.post('ceaa.requisicion', { telefonos: this.seleccion })
        this.validarSuccess(data.message + ' #' + data.id_requisicion)
        this.seleccion = []
        await this.initialize()
      } catch (error) {
        this.validarError(error.response && error.response.data ? error.response.data.message : 'No se pudo generar la requisición')
      } finally {
        this.generando = false
      }
    },

    textoDecision(decision) {
      if (decision === 'aceptada') return 'Aceptada'
      if (decision === 'rechazada') return 'Rechazada'
      return 'Pendiente'
    },

    colorDecision(decision) {
      if (decision === 'aceptada') return 'green'
      if (decision === 'rechazada') return 'red'
      return 'grey'
    },

    moneda(valor) {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(Number(valor) || 0)
    },

    formatoFecha(valor) {
      if (!valor) return '—'
      const [anio, mes, dia] = String(valor).substr(0, 10).split('-')
      return dia && mes && anio ? `${dia}/${mes}/${anio}` : String(valor)
    },
  },
}
</script>
